import { render, staticRenderFns } from "./friendsLinkAdd.vue?vue&type=template&id=611a397e&scoped=true"
import script from "./friendsLinkAdd.vue?vue&type=script&lang=js"
export * from "./friendsLinkAdd.vue?vue&type=script&lang=js"
import style0 from "./friendsLinkAdd.vue?vue&type=style&index=0&id=611a397e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a397e",
  null
  
)

export default component.exports